export default __webpack_public_path__ + "static/media/50t.ac2cde8f.jpg";